import { render, staticRenderFns } from "./PurchaseOptionCard.vue?vue&type=template&id=b1aa0fc2&scoped=true"
import script from "./PurchaseOptionCard.vue?vue&type=script&lang=ts"
export * from "./PurchaseOptionCard.vue?vue&type=script&lang=ts"
import style0 from "./PurchaseOptionCard.vue?vue&type=style&index=0&id=b1aa0fc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1aa0fc2",
  null
  
)

export default component.exports